import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    // const { getInterface } = this.props; # Unused prop, can be removed if not needed in the future
    return (
      <div
        className={`w-full bottom-0 shadow-md flex justify-center items-center py-8`}
      >
        <footer className="footer w-full lg:w-7/12 items-center flex flex-col lg:flex-row justify-center lg:justify-between px-2 py-2">
          {/* Powered by */}
          <div class="w-6/12 lg:w-3/12 flex justify-center lg:justify-normal mb-4 lg:mb-0">
            <p className="font-light text-gray-600 duration-500 hover:text-black text-md">
              Powered by
            </p>
            <a href="https://pages.github.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/github.png`}
                alt="Github"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
          </div>

          {/* Social Media */}
          <div className="flex">
            <a href="https://facebook.com">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/facebook.png`}
                alt="Facebook"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
            <a href="https://linkedin.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/linkedin.png`}
                alt="Linkedin"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
            <a href="https://youtube.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/youtube.png`}
                alt="Youtube"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
            <a href="https://twitter.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/twitter.png`}
                alt="Twitter"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
            <a href="https://instagram.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/instagram.png`}
                alt="Instagram"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
            <a href="https://github.com" className="pl-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/github.png`}
                alt="Github"
                className="w-8 lg:w-8 w-8 lg:h-8 transition duration-500 ease-in-out transform hover:scale-110"
              ></img>
            </a>
          </div>
        </footer>
      </div>
    );
  }
}
